import { url } from "../../../../../../utils/urls";

export const tooltipsContent = {
    methodToSelect: [
      {
        top: 'The top 10 articles are based on the total count of reactions, for the specified time period, including: comments, article sentiment reactions, and commenting emoji reactions.',
      },
      {
        top: 'The top 10 articles are based on the page views of that article for the specified time period.',
      },
    ],
    display: [
      {
          top: 'All top Trending Now articles shown on the page at the same time',
          bottom: `${url.tnu.pubPortal.images}/flat.jpg`,
      },
      {
          top: 'User can scroll through top Trending Now articles 2 at a time',
          bottom: `${url.tnu.pubPortal.images}/scroll.jpg`,
      },
      {
          top: 'Rail Scroll will add Trending now to the right or left rail of your web page. Visitors will still be able to scroll through articles based on how many “Top' +
            ' Articles” you want shown.',
          bottom: `${url.tnu.pubPortal.images}/rail_scroll.jpg`,
      },
      {
          top: 'Static ad as user scrolls through the top Trending Now articles',
          bottom: `${url.tnu.pubPortal.images}/scroll_ad.jpg`,
      },
    ]
  };
